import { render } from "./CurrencyComponent.vue?vue&type=template&id=3202fd42"
import script from "./CurrencyComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Currency/CurrencyComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3202fd42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3202fd42', __exports__)) {
    api.reload('3202fd42', __exports__)
  }
  
  module.hot.accept("./CurrencyComponent.vue?vue&type=template&id=3202fd42", () => {
    api.rerender('3202fd42', render)
  })

}


export default __exports__